import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { userDetailSelect } from "Layout/slice/selector";
import { trimmedName } from "utils/index";
import { EditIcon2 } from "assets/icons/index";
import {
  GradientDiv,
  ProfileDetailsHeaderContainer,
} from "../Profile/Profile.styles";
// import { SOCIAL_LINKS_DATA } from "utils/constants";

const ProfileDetailsHeader = ({ onEditClick }) => {
  const profileDetails = useSelector(userDetailSelect);

  return (
    <ProfileDetailsHeaderContainer>
      <GradientDiv />

      {profileDetails !== null && (
        <div className="profile-wrapper">
          <div className="img-profile">
            {profileDetails?.user_icon ? (
              <img src={profileDetails?.user_icon} alt="icon" />
            ) : (
              <div className="user-icon">
                {trimmedName(profileDetails?.first_name)}
              </div>
            )}
          </div>

          <div className="profile-details">
            <div className="profile-name">
              <h2>{`${profileDetails.first_name || "-"} ${
                profileDetails.last_name || ""
              }`}</h2>

              <div className="edit-button" onClick={onEditClick}>
                <img src={EditIcon2} alt="Edit" />
              </div>
            </div>
            {/* <span className="invest-text">Investment Corp</span> */}
            <p className="bio-text">{profileDetails?.bio || ""}</p>
            {/* <div className="social-links-container">
              {SOCIAL_LINKS_DATA.map((link, index) => (
                <div key={index} href={link.href} className="social-icon">
                  {link.icon}
                </div>
              ))}
            </div> */}
          </div>
        </div>
      )}
    </ProfileDetailsHeaderContainer>
  );
};

ProfileDetailsHeader.propTypes = {
  onEditClick: PropTypes.func,
};

export default ProfileDetailsHeader;
